import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home          from "./pages/Home";
import About         from "./pages/About";
import Events        from "./pages/Events";
import EventDetail   from "./pages/EventDetail";
import Membership    from "./pages/Membership";
import Login         from "./pages/Login";
import Dashboard     from "./pages/Dashboard";
import Blog          from "./pages/Blog";
import Sponsorship   from "./pages/Sponsorship";
import Opportunities from "./pages/Opportunities";
import SetPassword   from "./pages/SetPassword";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy  from "./pages/RefundPolicy";
import LeaderPortal  from "./pages/LeaderPortal";

// Redirects to /login if not authenticated
function ProtectedRoute({ children }) {
  const token = localStorage.getItem("accessToken");
  return token ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main style={{ minHeight: "80vh", padding: "2rem" }}>
          <Routes>
            <Route path="/"                         element={<Home />} />
            <Route path="/about"                    element={<About />} />
            <Route path="/events"                   element={<Events />} />
            <Route path="/events/:slug"             element={<EventDetail />} />
            <Route path="/membership"               element={<Membership />} />
            <Route path="/login"                    element={<Login />} />
            <Route path="/blog"                     element={<Blog />} />
            <Route path="/sponsorship"              element={<Sponsorship />} />
            <Route path="/opportunities"            element={<Opportunities />} />
            <Route path="/set-password/:uid/:token" element={<SetPassword />} />
            <Route path="/privacy-policy"           element={<PrivacyPolicy />} />
            <Route path="/refund-policy"            element={<RefundPolicy />} />

            {/* Protected — only logged-in members can access */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/leader-portal" element={
              <ProtectedRoute>
                <LeaderPortal />
              </ProtectedRoute>
            } />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;